import React from 'react';
import { handleStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Button,
} from '@leagueplatform/genesis-core';
import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';

export function SuccessModal(props: any) {
  const { onClose } = props;

  return (
    <StackLayout css={{ textAlign: 'center', minHeight: '100vh' }}>
      <Box
        css={
          {
            padding: '$four',
            marginTop: '$three',
            backgroundColor: 'White',
          } as GDSStyleObject
        }
      >
        <img
          style={{ cursor: 'pointer' }}
          src={
            handleStaticAsset(SHARED_LIBRARY_ASSET_KEYS.SUCCESS_ICON) as string
          }
          alt="right arrow icon"
          width="55px"
        />
        <HeadingText
          level="1"
          size={{
            '@initial': 'xxl',
            '@mobile': 'xl',
          }}
        >
          Your form was submitted successfully!
        </HeadingText>
        <HeadingText
          css={
            {
              margin: '$two $none',
            } as GDSStyleObject
          }
          level="3"
          size={{
            '@initial': 'lg',
            '@mobile': 'lg',
          }}
        >
          You will be contacted by phone after your request is processed.
        </HeadingText>
        <Button onClick={onClose}>Close</Button>
      </Box>
    </StackLayout>
  );
}
